import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { ActionIcon, StyledActionIcon } from './ActionIcon';
import SvgDelete from '../../../../../play-core/icons/Delete';
import { globalOutline } from '../../../../../play-core/styles/style-helper';
import { useVideoHistoryDispatch } from '../../../providers/VideoHistoryProvider/VideoHistoryContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const DeleteProgressAction = ({
  isHovering = true,
  mediaId
}) => {
  const historyDispatch = useVideoHistoryDispatch();
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsx(Fragment, {
    children: /*#__PURE__*/_jsx(DeleteIconButton, {
      isHovering: isHovering,
      onClick: () => historyDispatch({
        type: 'remove-history-entry',
        videoProgressId: mediaId
      }),
      "aria-label": t('global.delete'),
      children: /*#__PURE__*/_jsx(ActionIcon, {
        isActive: true,
        onClick: () => {},
        icon: /*#__PURE__*/_jsx(SvgDelete, {}),
        isHovering: isHovering,
        withOuterPadding: true
      })
    })
  });
};
const DeleteIconButton = styled.button.withConfig({
  displayName: "DeleteProgressAction__DeleteIconButton",
  componentId: "sc-uxclxf-0"
})(["cursor:pointer;display:flex;pointer-events:all;font-size:24px;&.focus-visible{> ", "{opacity:1;transform:scale(1.1);", ";}}"], StyledActionIcon, globalOutline);